<template>
  <div class="TestRecords">
    <div
      :class="[
        'testRecords-tools',
        TesRecordsPageData.isOpen ? 'testRecords-tools-open' : '',
      ]"
    >
      <div class="more-title">API call log query</div>
      <div class="title-desc">Query and monitor API interface call records</div>
      <div class="search-form">
        <el-form
          :inline="true"
          :model="searchform"
          class="demo-form-inline"
          label-position="top"
        >
          <div class="search-fields">
            <el-form-item label="App Key">
              <el-input
                v-model="searchform.appKey"
                placeholder="Enter app key"
              ></el-input>
            </el-form-item>
            <el-form-item label="API Name">
              <el-input
                v-model="searchform.apiName"
                placeholder="Enter API name"
              ></el-input>
            </el-form-item>
            <el-form-item label="API URL">
              <el-input
                v-model="searchform.apiUrl"
                placeholder="Enter API URL"
              ></el-input>
            </el-form-item>
          </div>
          <div class="search-fields">
            <el-form-item label="Request Method">
              <el-select
                v-model="searchform.method"
                placeholder="Select"
                style="width: 100%"
                clearable
              >
                <el-option
                  v-for="item in methodOptions"
                  :key="item.label"
                  :label="item.label"
                  :value="item.label"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Call status">
              <el-select
                v-model="searchform.callStatus"
                placeholder="Select"
                style="width: 100%"
                clearable
              >
                <el-option
                  v-for="item in callStatusOptions"
                  :key="item.label"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Contains Data">
              <el-select
                v-model="searchform.callIncludingData"
                placeholder="Select"
                style="width: 100%"
                clearable
              >
                <el-option
                  v-for="item in callIncludingDataOptions"
                  :key="item.label"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="search-actions">
            <el-form-item label="Time range">
              <el-date-picker
                style="width: 100%"
                v-model="searchform.timePicker"
                range-separator=""
                start-placeholder="Start date"
                type="daterange"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']"
                end-placeholder="End date"
              ></el-date-picker>
            </el-form-item>
            <div class="search-btn">
              <el-button
                icon="el-icon-refresh-right"
                class="resetbtn"
                @click="resetClick()"
                >Reset</el-button
              >
              <el-button
                type="primary"
                icon="el-icon-search"
                @click="getapiDataCallQueryPage()"
                >Search</el-button
              >
              <el-button type="text" class="unfoldbtn" @click="UnfoldClick()"
                >Unfold
                <img
                  src="@/assets/images/dataServices/dataapi-img/Vector.svg"
                  alt=""
              /></el-button>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <div class="more-table-in">
      <div class="more-title marginbottom20">Test Records</div>
      <el-table
        ref="Usagelist"
        class="table_box table_height_30 table_font_size_14"
        :data="apiDataCallQueryList"
        style="width: 100%"
        empty-text="No Data"
      >
        <el-table-column
          prop="apiIdStr"
          label="ID"
          align="left"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="appKey"
          label="App Key"
          align="left"
          show-overflow-tooltip
          min-width="200"
        ></el-table-column>
        <el-table-column
          prop="apiName"
          label="APP Name"
          align="left"
          show-overflow-tooltip
          min-width="200"
        ></el-table-column>

        <el-table-column
          prop="method"
          label="Method"
          align="left"
          show-overflow-tooltip
          min-width="200"
        >
          <template slot-scope="scope">
            <span class="methodStyle">{{ scope.row.method }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="Call Time"
          align="left"
          show-overflow-tooltip
          min-width="200"
        >
          <template slot-scope="scope">
            {{ $formatDateTime(scope.row.createTime, "yyyy-MM-dd hh:mm:ss") }}
          </template>
        </el-table-column>
        <el-table-column
          prop="callStatus"
          label="Status"
          align="left"
          show-overflow-tooltip
          min-width="200"
        >
          <template slot-scope="scope">
            <span
              :class="[
                'point-taskStatus',
                scope.row.callStatus == 1 ? 'success' : 'failed',
              ]"
            >
            </span>
            <span :class="[scope.row.callStatus == 1 ? 'success' : 'failed']">{{
              scope.row.callStatus == 1 ? "Success" : "Failed"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="callIncludingData"
          label="Has Data"
          align="left"
          show-overflow-tooltip
          min-width="200"
        >
          <template slot-scope="scope">
            {{ scope.row.callIncludingData == 1 ? "Has Data" : "No Data" }}
          </template>
        </el-table-column>
        <el-table-column
          prop=""
          label="Operations"
          align="center"
          width="150"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div>
              <div class="dataClean-operate" @click="toDetails(scope.row)">
                Details
              </div>
            </div>
          </template>
        </el-table-column>
        <template slot="empty">
          <div>
            <img
              style="width: 50%; height: 50%"
              src="../../../assets/images/noDate.png"
              alt=""
            />
          </div>
        </template>
      </el-table>
      <div class="page_i_box dataService">
        <Page
          :totalFont="true"
          :total="page.total"
          :pageSize.sync="page.pageSize"
          :currentPage="page.pageNo"
          @onPageChange="onPageChangeList"
        ></Page>

        <div class="search_rsult_txt line_2">
          {{ page.pageNo }}-{{ page.pageSize }} of over
          {{ page.total | FilterNum }} results for "Data API"
        </div>
      </div>
    </div>
    <!-- detail弹框 -->
    <el-dialog
      title="Detail"
      :visible.sync="detailDialogVisible"
      class="applyDialog"
      center
    >
      <p class="desc-title">params</p>
      <div class="info-list-desc-content">
        <div class="copyimgbtn" @click="copybtn(paramsRow)">
          <img
            src="../../../assets/images/dataServices/dataapi-img/copytestbtn.svg"
            alt=""
          />
        </div>
        <div>
          <pre>{{ formattedJson(paramsRow) }}</pre>
        </div>
      </div>
      <p class="desc-title">result</p>
      <div class="info-list-desc-content">
        <div class="copyimgbtn" @click="copybtn(resultRow)">
          <img
            src="../../../assets/images/dataServices/dataapi-img/copytestbtn.svg"
            alt=""
          />
        </div>
        <div>
          <pre>{{ formattedJson(resultRow) }}</pre>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { apiDataCallQueryPage } from "@/api/dataServicesApi";
import Page from "@/components/page/index.vue";
export default {
  props: ["TesRecordsPageData"],
  name: "TestRecords",
  data() {
    return {
      // isOpen: false,
      searchform: {
        appKey: "",
        apiName: "",
        apiUrl: "",
        method: "",
        callStatus: "",
        timePicker: [],
      },
      methodOptions: [
        {
          label: "GET",
        },
        {
          label: "POST",
        },
      ],
      callStatusOptions: [
        {
          value: 0,
          label: "Fail",
        },
        {
          value: 1,
          label: "Success",
        },
      ],
      callIncludingDataOptions: [
        {
          value: 0,
          label: "No",
        },
        {
          value: 1,
          label: "Yes",
        },
      ],
      apiDataCallQueryList: [],
      detailDialogVisible: false,
      paramsRow: {},
      resultRow: {},
      page: {
        pageSize: 10,
        pageNo: 1,
        total: 0,
      },
    };
  },
  components: {
    Page,
  },
  computed: {},
  watch: {},
  created() {
    this.getapiDataCallQueryPage();
  },
  mounted() {},

  methods: {
    UnfoldClick() {
      this.$emit("fitlers");
    },
    resetClick() {
      this.searchform = {
        appKey: "",
        apiName: "",
        apiUrl: "",
        method: "",
        callStatus: "",
        timePicker: [],
      };
    },
    getapiDataCallQueryPage() {
      let params = {
        page: this.page.pageNo,
        pageSize: this.page.pageSize,
        appKey: this.searchform.appKey,
        apiName: this.searchform.apiName,
        apiUrl: this.searchform.apiUrl,
        method: this.searchform.method,
        callStatus: this.searchform.callStatus,
        startTime: this.searchform.timePicker[0] || "",
        endTime: this.searchform.timePicker[1] || "",
      };
      apiDataCallQueryPage(params).then((res) => {
        if (res.code == 200) {
          this.apiDataCallQueryList = JSON.parse(JSON.stringify(res.data.rows));
          console.log("this.apiDataCallQueryList", this.apiDataCallQueryList);
          this.page.total = res.data.total;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    onPageChangeList({ page, size }) {
      this.page.pageSize = size;
      this.page.pageNo = page;
      this.getapiDataCallQueryPage();
    },
    toDetails(row) {
      this.paramsRow = JSON.stringify(JSON.parse(row.params));
      this.resultRow = JSON.stringify(JSON.parse(row.result));
      this.detailDialogVisible = true;
    },
    // 展示json对象
    formattedJson(data) {
      if (!data) return;
      try {
        let obj = JSON.parse(data);
        return JSON.stringify(obj, null, 2); // 2 个空格缩进
      } catch (e) {
        console.log("e", e);
        return "Invalid JSON";
      }
    },
    copybtn(row) {
      this.copyTool(row);
    },
    async copyTool(data) {
      try {
        await this.$copyText(data);
        this.$message({
          message: "Copied",
          type: "success",
        });
      } catch (err) {
        this.$message({
          message: "Failed to copy: " + err,
          type: "warning",
        });
      }
    },
  },
};
</script>

<style scoped>
.TestRecords {
}
.testRecords-tools {
  background-color: #fff;
  max-height: 115px;
  border-radius: 10px;
  margin-bottom: 20px;
  padding: 30px 40px;
  box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.12);
  overflow: hidden;
  transition: max-height 0.3s ease;
}
.testRecords-tools.testRecords-tools-open {
  max-height: 470px;
}
.more-title {
  color: #1a2332;
  font-size: 20px;
  margin-bottom: 12px;
  font-weight: bold;
}
.title-desc {
  color: #666666;
  font-size: 16px;
  margin-bottom: 35px;
}
.more-title.marginbottom20 {
  margin-bottom: 20px;
}
/* 每行最多3个，自动换行 */
.search-form .search-fields,
.search-form .search-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.search-form .search-fields .el-form-item,
.search-form .search-actions .el-form-item {
  width: 30%;
}
.search-form .search-actions .search-btn {
  text-align: right;
  width: 60%;
}
.search-form /deep/ .el-form--label-top .el-form-item__label {
  font-size: 16px !important;
  color: #1a2332 !important;
  padding: 0px;
  margin-bottom: 13px;
}
.search-form /deep/ .el-input__inner::placeholder,
.search-form /deep/ .el-range-input::placeholder {
  color: #999999 !important;
  font-size: 16px;
  opacity: 1; /* 某些浏览器需要 */
}
.search-form /deep/ .el-input,
.search-form /deep/ .el-date-editor .el-range-input {
  font-size: 16px;
  color: #1a2332 !important;
}
.search-form /deep/ .el-date-editor--daterange.el-input__inner {
  height: 50px;
}
.search-form /deep/ .el-form-item {
  margin-bottom: 20px;
}
.search-form /deep/ .el-button {
  font-size: 16px;
}
.search-form .resetbtn {
  border: 1px solid #cccccc;
}
.search-form .unfoldbtn {
  color: #b98b73;
  padding: 0;
}
/* 表格样式 */
.more-table-in {
  background: #ffffff;
  box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  padding: 30px 40px;
}
.more-table-in /deep/ .el-table__empty-text {
  padding: 85px 0;
}
.more-table-in /deep/ th.el-table__cell {
  background: #f3f3f3;
}
.more-table-in /deep/ td.el-table__cell {
  height: auto;
  padding: 18px 0;
}
.more-table-in /deep/ th.el-table__cell {
  padding: 13px 0;
}
.more-table-in /deep/ .cell {
  font-size: 16px !important;
}
.more-table-in /deep/ .el-table__expand-icon {
  display: block !important;
}
.more-table-in /deep/ .el-table__expand-icon .el-icon-arrow-right {
  left: 50%;
  top: 50%;
  margin: 0;
  right: auto;
  transform: translate(-50%, -50%) rotate(90deg);
}
.more-table-in
  /deep/
  .el-table__expand-icon.el-table__expand-icon--expanded
  .el-icon-arrow-right {
  transform: translate(-50%, -50%) rotate(180deg);
}
.more-table-in /deep/ .el-table__expanded-cell {
  background: #f0f0f0 !important;
  padding: 14px !important;
}
.more-table-in /deep/ .el-table__expanded-cell:hover {
  background: #f0f0f0 !important;
}
.more-table-in /deep/ .expanded td.el-table__cell {
  border-bottom: 0 !important;
}
.more-table-in /deep/ .tree_table_box {
  padding: 0 !important;
}
.more-table-in .dataClean-operate {
  font-size: 16px;
  color: #b98b73;
  height: 15px;
  line-height: 15px;
  padding: 0 15px;
  white-space: nowrap;
  cursor: pointer;
  display: inline-block;
}
.more-table-in .dataClean-operate:not(:last-child) {
  border-right: 1px solid #d3d3d3;
}
.more-table-in .dataClean-operate:first-of-type {
  padding-left: 0;
}
.more-table-in .dataClean-operate:last-of-type {
  padding-right: 0;
}
.point-taskStatus {
  width: 8px;
  height: 8px;
  background: #ccc;
  display: inline-block;
  vertical-align: middle;
  border-radius: 50%;
  margin-right: 8px;
}
.point-taskStatus.success {
  background: #02815c;
}
.point-taskStatus.failed {
  background: #f55656;
}
.success {
  color: #02815c;
}
.failed {
  color: #f55656;
}
.applyDialog /deep/.el-dialog {
  width: 800px;
}
.applyDialog /deep/.el-dialog__body {
  border-radius: none !important;
  box-shadow: none !important;
  max-height: 700px;
  overflow: auto;
}
.applyDialog /deep/.el-dialog__body .desc-title {
  font-size: 20px;
  margin: 10px 0;
}
.applyDialog /deep/ .el-input__inner {
  height: 50px !important;
  line-height: 50px !important;
}
.applyDialog /deep/ .el-dialog__header {
  padding: 30px 0 0 0;
}
.applyDialog /deep/ .el-dialog__header .el-dialog__title {
  font-size: 30px;
  color: #1a2332;
}
.info-list-title {
  font-size: 20px;
  color: #1a2332;
}
.btn-box {
  margin-bottom: 20px;
}
.info-list-desc-content {
  background-color: #f5f5f5;
  padding: 40px;
  border: 1px solid #dddddd;
  color: #1a2332;
  font-size: 20px;
}
.copyimgbtn {
  text-align: right;
}
.copyimgbtn img {
  cursor: pointer;
  width: 26px;
  height: 26px;
}
.methodStyle {
  display: inline-block;
  padding: 5px 8px;
  background: #faf1ec;
  border-radius: 6px;
  color: #b98b73;
}
pre {
  white-space: pre-wrap; /* 保留原始格式，同时允许自动换行 */
  word-wrap: break-word; /* 兼容旧浏览器 */
  overflow-wrap: break-word; /* 现代标准：在长单词必要时断行 */
  /* 可选：防止意外溢出 */
  overflow-x: hidden;
}
/* 大版本及中版本：media的范围（1920px至1440px）; */
@media (max-width: 1920px) {
  /* 字体 标题改成20px */
  .applyDialog /deep/ .el-dialog__header .el-dialog__title {
    font-size: 20px;
  }
  /* 字体 内容改成16px 包括按钮里字体*/
  .search_rsult_txt,
  .page_txt,
  .applyDialog /deep/.el-dialog__body .desc-title,
  .info-list-desc-content {
    font-size: 16px;
  }
  /* .title-desc{
    margin-bottom:40px;
  } */
  /* 圆角 改成10px */
  .more-table-in {
    border-radius: 10px;
  }
  /* padding *0.75 */
  .testRecords-tools,
  .more-table-in {
    padding: 30px 30px;
  }
  /* margin *0.75 */
  /* 表格 表头高度 44px 内容高度50px */
  .more-table-in /deep/ thead {
    height: auto !important;
  }
  .more-table-in /deep/ th.el-table__cell,
  .more-table-in /deep/ .has-gutter .el-table__cell {
    height: auto !important;
    padding: 7px 0;
  }
  .more-table-in /deep/ td.el-table__cell {
    padding: 10px 0;
  }
  /* 弹框宽度*0.75 */
  .applyDialog /deep/.el-dialog {
    width: 600px;
  }
}
/* 小版本：media的范围（1440px以下）; */
@media (max-width: 1440px) {
  /* 字体 标题改成18px */
  .more-title{
    font-size: 18px;
  }
  /* 字体 内容改成14px 包括按钮里字体*/
  .title-desc,
  .search-form /deep/ .el-form--label-top .el-form-item__label,
  .dataServices-theme .el-select-dropdown__item,
  .search-form /deep/ .el-button,
  .more-table-in /deep/ .cell,
  .more-table-in .dataClean-operate,
  .search_rsult_txt,
  .page_txt,
  .search-form /deep/ .el-input__inner::placeholder,
  .search-form /deep/ .el-range-input::placeholder,
  .search-form /deep/ .el-input,
  .search-form /deep/ .el-date-editor .el-range-input
   {
    font-size: 14px !important;
  }
  /* 圆角 改成8px */
  .more-table-in {
    border-radius: 8px;
  }
  /* padding *0.67 */
  .testRecords-tools,
  .more-table-in {
    padding: 30px 27px;
  }
  /* margin *0.67 */
  /* 表格 表头高度 40px 内容高度44px*/
  .more-table-in /deep/ thead {
    height: auto !important;
  }
  .more-table-in /deep/ th.el-table__cell,
  .more-table-in /deep/ .has-gutter .el-table__cell {
    height: auto !important;
    padding: 10px 0;
  }
  .more-table-in /deep/ td.el-table__cell {
    padding: 13px 0;
  }
  /* 弹框宽度*0.67 */
  .applyDialog /deep/.el-dialog {
    width: 536px;
  }
}
</style>
